import React from 'react';
import { Phone, Mail, MessageCircle, Clock, ExternalLink } from 'lucide-react';

const Footer = ({ siteSettings }) => {
  const { 
    contact_phone, 
    contact_whatsapp, 
    contact_email, 
    operating_hours 
  } = siteSettings || {};

  return (
    <footer className="bg-[#0D0D0D] border-t border-white/10 mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* Left - Fish on Fire Logo + Powered by Fressea */}
          <div className="flex flex-col items-start">
            <img 
              src="/fnf-logo-footer.png" 
              alt="Fish on Fire" 
              className="h-24 object-contain mb-4"
            />
            <div className="flex flex-col items-start mt-2">
              <span className="text-gray-500 text-xs">Powered by</span>
              <a 
                href="https://fresseafoods.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity -mt-1"
              >
                <img 
                  src="/fressea-logo-large.png" 
                  alt="Fressea" 
                  className="h-24 object-contain"
                />
              </a>
            </div>
          </div>

          {/* Middle - Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Contact Us</h3>
            <div className="space-y-3">
              {contact_phone && (
                <a href={`tel:${contact_phone}`} className="flex items-center gap-3 text-gray-400 hover:text-orange-500 transition-colors">
                  <Phone className="w-5 h-5" />
                  <span>{contact_phone}</span>
                </a>
              )}
              {contact_whatsapp && (
                <a 
                  href={`https://wa.me/${contact_whatsapp.replace(/[^0-9]/g, '')}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-green-500 transition-colors"
                >
                  <MessageCircle className="w-5 h-5" />
                  <span>WhatsApp: {contact_whatsapp}</span>
                </a>
              )}
              {contact_email && (
                <a href={`mailto:${contact_email}`} className="flex items-center gap-3 text-gray-400 hover:text-orange-500 transition-colors">
                  <Mail className="w-5 h-5" />
                  <span>{contact_email}</span>
                </a>
              )}
              {operating_hours && (
                <div className="flex items-center gap-3 text-gray-400">
                  <Clock className="w-5 h-5" />
                  <span>{operating_hours}</span>
                </div>
              )}
            </div>
          </div>

          {/* Right - Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Quick Links</h3>
            <div className="space-y-3">
              <a 
                href="https://fresseafoods.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-400 hover:text-orange-500 transition-colors"
              >
                <ExternalLink className="w-5 h-5" />
                <span>Visit fresseafoods.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-8 pt-6 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Fish on Fire. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
